
(function () {
  if (window.__llwlLiveBooted) return;
  window.__llwlLiveBooted = true;

  var K_WATCH = 'll_watchlist';
  var K_LEGACY = 'll_preorder_watch';
  var K_SNAP = 'll_watchlist_snap';
  var K_SEEN = 'll_watchlist_live_seen'; /* session: suppress duplicate toasts */
  var MAX_TOASTS = 3;
  var FETCH_GAP = 120;
  var TITLE_MAX = 42;
  var HOLD_MS = 5500;

  var THEMES = [
    {
      id: 'pokemon',
      acc: '#f5b800',
      on: '#1b1b1f',
      ink: '#9a7300',
      match: ['pokemon', 'pokémon'],
      icon: 'https://lockett-labs.com/cdn/shop/files/png-clipart-pokeball-pokeball-thumbnail-Photoroom.png?v=1785786875&width=300'
    },
    {
      id: 'lorcana',
      acc: '#7c5cff',
      on: '#ffffff',
      ink: '#5a3fd4',
      match: ['lorcana', 'disney'],
      icon: 'https://lockett-labs.com/cdn/shop/files/lorcana_tcg_symbols___basic_ink__vector_file__by_roshmalum_dhro31k-pre.png?v=1785705932&width=300'
    },
    {
      id: 'onepiece',
      acc: '#2f74d0',
      on: '#ffffff',
      ink: '#1f5aad',
      match: ['one piece', 'onepiece'],
      icon: 'https://lockett-labs.com/cdn/shop/files/cartoon-pirate-skull-with-hat-free-png.webp?v=1785717154&width=300'
    },
    {
      id: 'magic',
      acc: '#a5202a',
      on: '#ffffff',
      ink: '#8a1b24',
      match: ['magic the gathering', 'magic: the gathering', ' mtg', 'mtg ', 'mtg,', 'wizards of the coast'],
      icon: 'https://lockett-labs.com/cdn/shop/files/png-clipart-magic-the-gathering-puzzle-quest-magic-points-playing-card-symbol-symbol-miscellaneous-game-thumbnail-Photoroom.png?v=1785705960&width=300'
    },
    {
      id: 'digimon',
      acc: '#12a594',
      on: '#ffffff',
      ink: '#0d7f72',
      match: ['digimon'],
      icon: 'https://lockett-labs.com/cdn/shop/files/terriermon-renamon-impmon-digimon-logo-png-favpng-qKkQ2jkCesxE8rkv1RRbUmp7S-Photoroom.png?v=1785786846&width=300'
    },
    {
      id: 'vaultx',
      acc: '#111827',
      on: '#ffffff',
      ink: '#111827',
      match: ['vault x', 'vaultx'],
      icon: 'https://lockett-labs.com/cdn/shop/files/0x0.png?v=1785786016&width=300'
    },
    {
      id: 'ultrapro',
      acc: '#c41230',
      on: '#ffffff',
      ink: '#a00e28',
      match: ['ultra pro', 'ultrapro'],
      icon: 'https://lockett-labs.com/cdn/shop/files/598-5989644_sponsored-by-ultra-pro-logo.png?v=1785786128&width=300'
    },
    {
      id: 'dragonshield',
      acc: '#e85d04',
      on: '#ffffff',
      ink: '#c44e04',
      match: ['dragon shield', 'dragonshield'],
      icon: 'https://lockett-labs.com/cdn/shop/files/86-865999_transparent-shield-and-banner-png-dragon-shield-sleeves-Photoroom.png?v=1785786048&width=300'
    },
    {
      id: 'gamegenic',
      acc: '#5b2c6f',
      on: '#ffffff',
      ink: '#4a235a',
      match: ['gamegenic'],
      icon: 'https://lockett-labs.com/cdn/shop/files/ae072dd0223bd1f89cada5c5ce9e39bd7b3d64345b1439330adb66e2-Photoroom.png?v=1785786804&width=300'
    },
    {
      id: 'cardconcept',
      acc: '#0d9488',
      on: '#ffffff',
      ink: '#0a7a70',
      match: ['card concept', 'cardconcept'],
      icon: 'https://lockett-labs.com/cdn/shop/files/card_concept_logo.avif?v=1785786165&width=300'
    }
  ];

  var DEFAULT_THEME = {
    id: 'default',
    acc: '#f2542d',
    on: '#ffffff',
    ink: '#c43d1f',
    icon: null
  };

  var host = null;
  var stack = null;
  var pollMs = 5000;
  var watchUrl = '/pages/watchlist';
  var currency = 'GBP';
  var timer = null;
  var busy = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function readJSON(store, key, fb) {
    try { var v = store.getItem(key); return v ? JSON.parse(v) : fb; } catch (e) { return fb; }
  }
  function writeJSON(store, key, val) {
    try { store.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function isArr(v) { return Object.prototype.toString.call(v) === '[object Array]'; }
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: currency || 'GBP'
      }).format(v);
    } catch (e) { return '£' + v.toFixed(2); }
  }
  function clip(str, n) {
    str = String(str || '');
    if (str.length <= n) return str;
    return str.slice(0, n - 1).replace(/\s+\S*$/, '') + '…';
  }
  function uniq(list) {
    var out = [], seen = {};
    (list || []).forEach(function (h) {
      if (!h || seen[h]) return;
      seen[h] = 1;
      out.push(h);
    });
    return out;
  }

  function readWatch() {
    var sharedRaw = null;
    try { sharedRaw = localStorage.getItem(K_WATCH); } catch (e) {}
    if (sharedRaw != null) {
      var shared = readJSON(localStorage, K_WATCH, []);
      return uniq(isArr(shared) ? shared : []).slice(0, 100);
    }
    var legacy = readJSON(localStorage, K_LEGACY, []);
    if (!isArr(legacy)) legacy = [];
    return uniq(legacy).slice(0, 100);
  }
  function readSnap() {
    var s = readJSON(localStorage, K_SNAP, {});
    return s && typeof s === 'object' ? s : {};
  }
  function writeSnap(map) { writeJSON(localStorage, K_SNAP, map); }
  function readSeen() {
    var s = readJSON(sessionStorage, K_SEEN, {});
    return s && typeof s === 'object' ? s : {};
  }
  function writeSeen(map) { writeJSON(sessionStorage, K_SEEN, map); }

  function isPreorderProduct(p) {
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var type = String(p.type || '').toLowerCase();
    var title = String(p.title || '').toLowerCase();
    var hay = tags.join('|') + '|' + type + '|' + title;
    return /pre[\s-]?order|coming\s*soon|allocation/.test(hay);
  }

  function productHay(p) {
    var tags = (p.tags || []).join(' ');
    return [
      p.title || '',
      p.type || '',
      p.vendor || '',
      tags,
      p.handle || ''
    ].join(' ').toLowerCase();
  }

  function productImage(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (!img) return '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    /* Prefer a small CDN size when Shopify image URLs are used. */
    if (img.indexOf('cdn.shopify.com') > -1 || img.indexOf('/cdn/shop/') > -1) {
      if (img.indexOf('width=') === -1) {
        img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
      }
    }
    return img;
  }

  function resolveTheme(p) {
    var hay = ' ' + productHay(p) + ' ';
    for (var i = 0; i < THEMES.length; i++) {
      var theme = THEMES[i];
      for (var j = 0; j < theme.match.length; j++) {
        if (hay.indexOf(String(theme.match[j]).toLowerCase()) > -1) return theme;
      }
    }
    return DEFAULT_THEME;
  }

  function fetchProduct(handle) {
    var key = 'll_wv_' + handle;
    var hit = readJSON(sessionStorage, key, null);
    if (hit && hit.t && (Date.now() - hit.t) < 60000) return Promise.resolve(hit.p);
    return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
      .then(function (p) {
        writeJSON(sessionStorage, key, { t: Date.now(), p: p });
        return p;
      });
  }

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  var ICONS = {
    drop: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 4.5 12h4.2v9h6.6v-9h4.2L12 3Z"/></svg>',
    stock: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.6 16.6 5 12l1.4-1.4 3.2 3.2 8-8L19 7.2z"/></svg>',
    sold: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm3.7 13.3-1.4 1.4L12 13.4l-2.3 2.3-1.4-1.4L10.6 12 8.3 9.7l1.4-1.4L12 10.6l2.3-2.3 1.4 1.4L13.4 12l2.3 2.3Z"/></svg>',
    pre: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 2a1 1 0 0 0-1 1v1H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V3a1 1 0 1 0-2 0v1H9V3a1 1 0 0 0-1-1Zm11 8H5v9h14v-9Z"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12 19 6.4 17.6 5 12 10.6 6.4 5Z"/></svg>'
  };

  function ensureHost() {
    host = document.querySelector('[data-llwl-live]');
    if (!host) return false;
    stack = host.querySelector('[data-llwl-live-stack]');
    pollMs = Math.max(5000, parseInt(host.getAttribute('data-poll'), 10) || 5000);
    watchUrl = host.getAttribute('data-watch-url') || '/pages/watchlist';
    currency = host.getAttribute('data-currency') || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    return !!stack;
  }

  function showHost() {
    if (!host) return;
    host.hidden = false;
    host.classList.add('is-on');
    host.setAttribute('aria-hidden', 'false');
  }

  function hideHostIfEmpty() {
    if (!host || !stack) return;
    if (stack.children.length) return;
    host.hidden = true;
    host.classList.remove('is-on');
    host.setAttribute('aria-hidden', 'true');
  }

  function dismissToast(el) {
    if (!el || el.dataset.leaving === '1') return;
    if (el.dataset.hover === '1') return;
    el.dataset.leaving = '1';
    clearTimeout(el._hideTimer);
    el.classList.remove('is-in');
    el.classList.add('is-out');
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
      hideHostIfEmpty();
    }, reduce ? 0 : 420);
  }

  function armDismiss(el) {
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(function () {
      if (el.dataset.hover === '1') return;
      dismissToast(el);
    }, HOLD_MS);
  }

  function pushToast(alert) {
    if (!ensureHost() || !alert) return;
    showHost();

    while (stack.children.length >= MAX_TOASTS) {
      var oldest = stack.firstElementChild;
      if (oldest) {
        oldest.dataset.hover = '0';
        oldest.dataset.leaving = '';
        dismissToast(oldest);
      } else break;
    }

    var theme = alert.theme || DEFAULT_THEME;
    var el = document.createElement('article');
    el.className = 'llwl-live__toast';
    el.setAttribute('data-k', alert.kind);
    el.setAttribute('data-theme', theme.id || 'default');
    el.setAttribute('role', 'status');
    el.style.setProperty('--theme-acc', theme.acc);
    el.style.setProperty('--theme-on', theme.on);
    el.style.setProperty('--theme-ink', theme.ink);

    var url = rootUrl() + 'products/' + encodeURIComponent(alert.handle);
    var icoHtml = alert.image
      ? '<img src="' + alert.image + '" alt="" width="88" height="88" loading="lazy" decoding="async">'
      : (ICONS[alert.kind] || ICONS.stock);

    el.innerHTML =
      '<div class="llwl-live__ico" aria-hidden="true">' + icoHtml + '</div>' +
      '<div class="llwl-live__body">' +
        '<p class="llwl-live__title"></p>' +
        '<p class="llwl-live__text"></p>' +
        '<div class="llwl-live__actions">' +
          '<a class="llwl-live__link" data-p href="#"></a>' +
          '<a class="llwl-live__link" href="' + watchUrl + '">Watchlist</a>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="llwl-live__x" aria-label="Dismiss">' + ICONS.x + '</button>';

    el.querySelector('.llwl-live__title').textContent = alert.title;
    el.querySelector('.llwl-live__text').textContent = alert.body;
    var pLink = el.querySelector('[data-p]');
    pLink.href = url;
    pLink.textContent = 'View product';

    el.querySelector('.llwl-live__x').addEventListener('click', function () {
      el.dataset.hover = '0';
      dismissToast(el);
    });

    el.addEventListener('mouseenter', function () {
      el.dataset.hover = '1';
      clearTimeout(el._hideTimer);
    });
    el.addEventListener('mouseleave', function () {
      el.dataset.hover = '0';
      armDismiss(el);
    });

    stack.appendChild(el);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    });

    armDismiss(el);
  }

  function markSeen(key) {
    var seen = readSeen();
    seen[key] = Date.now();
    /* Keep session map small. */
    var keys = Object.keys(seen);
    if (keys.length > 80) {
      keys.sort(function (a, b) { return seen[a] - seen[b]; });
      keys.slice(0, keys.length - 60).forEach(function (k) { delete seen[k]; });
    }
    writeSeen(seen);
  }

  function alreadySeen(key) {
    return !!readSeen()[key];
  }

  function detectAlerts(handle, product, prev) {
    var price = Number(product.price) || 0;
    var available = !!product.available;
    var pre = isPreorderProduct(product);
    var theme = resolveTheme(product);
    var image = productImage(product);
    var alerts = [];

    if (!prev || prev._seed !== false) {
      /* First sighting: seed only, never toast. */
      return { alerts: alerts, snap: {
        price: price,
        lastPrice: price,
        lastAvailable: available,
        available: available,
        prePending: pre && !available,
        stockAck: false,
        preOpenAck: false,
        t: Date.now(),
        _seed: false
      }};
    }

    var lastPrice = (typeof prev.lastPrice === 'number') ? prev.lastPrice : Number(prev.price) || 0;
    var lastAvail = (typeof prev.lastAvailable === 'boolean')
      ? prev.lastAvailable
      : !!prev.available;
    var wasPrePending = !!prev.prePending;
    var title = clip(product.title || handle, TITLE_MAX);

    if (lastAvail === true && available === false) {
      alerts.push({
        kind: 'sold',
        handle: handle,
        theme: theme,
        image: image,
        title: 'Sold out',
        body: title + ' has sold out. Still on your watchlist for when it comes back in stock.',
        key: handle + ':sold:' + lastPrice + ':1'
      });
    }

    if (lastAvail === false && available === true) {
      if (wasPrePending && pre) {
        alerts.push({
          kind: 'pre',
          handle: handle,
          theme: theme,
          image: image,
          title: 'Pre-order now available',
          body: 'Pre-order is now open for ' + title + '.',
          key: handle + ':preopen:1'
        });
      } else {
        alerts.push({
          kind: 'stock',
          handle: handle,
          theme: theme,
          image: image,
          title: 'Back in stock',
          body: title + ' is available again.',
          key: handle + ':stock:1'
        });
      }
    }

    if (lastPrice > 0 && price > 0 && price < lastPrice) {
      alerts.push({
        kind: 'drop',
        handle: handle,
        theme: theme,
        image: image,
        title: 'Price drop',
        body: title + ' has gone down in price. Now ' + money(price) + ' (was ' + money(lastPrice) + ').',
        key: handle + ':drop:' + lastPrice + ':' + price
      });
    }

    var watchPrice = Number(prev.price);
    if (!(watchPrice > 0)) watchPrice = price;

    return {
      alerts: alerts,
      snap: {
        price: watchPrice,
        lastPrice: price,
        lastAvailable: available,
        available: available,
        prePending: pre && !available,
        stockAck: available ? (!!prev.stockAck || (lastAvail === false && available)) : false,
        preOpenAck: (pre && !available) ? false : (!!prev.preOpenAck || (wasPrePending && available && pre)),
        t: prev.t || Date.now(),
        _seed: false
      }
    };
  }

  function pruneSnaps(list, snaps) {
    var keep = {};
    list.forEach(function (h) { if (snaps[h]) keep[h] = snaps[h]; });
    return keep;
  }

  function pruneSeen(list) {
    var seen = readSeen();
    var allow = {};
    list.forEach(function (h) { allow[h] = 1; });
    Object.keys(seen).forEach(function (k) {
      var handle = k.split(':')[0];
      if (!allow[handle]) delete seen[k];
    });
    writeSeen(seen);
  }

  function tick() {
    if (busy) return;
    if (document.hidden) return;
    if (!ensureHost()) return;

    var list = readWatch();
    var snaps = pruneSnaps(list, readSnap());
    writeSnap(snaps);
    pruneSeen(list);

    if (!list.length) return;

    busy = true;
    var i = 0;
    var nextSnaps = Object.assign({}, snaps);
    var queue = [];

    function step() {
      if (i >= list.length) {
        writeSnap(nextSnaps);
        queue.forEach(function (a) {
          if (alreadySeen(a.key)) return;
          markSeen(a.key);
          pushToast(a);
        });
        busy = false;
        return;
      }

      var handle = list[i++];
      fetchProduct(handle)
        .then(function (p) {
          var result = detectAlerts(handle, p, snaps[handle] || null);
          nextSnaps[handle] = result.snap;
          (result.alerts || []).forEach(function (a) { queue.push(a); });
        })
        .catch(function () {
          /* Product deleted — drop from tracking next prune if hubs remove it.
             Do not auto-remove from watchlist here; page/hubs already prune. */
        })
        .then(function () {
          return sleep(FETCH_GAP);
        })
        .then(step);
    }

    step();
  }

  function schedule() {
    clearInterval(timer);
    timer = setInterval(tick, pollMs);
  }

  function boot() {
    if (!ensureHost()) return;

    /* Public hook so hubs / watchlist page can force a check after add/remove. */
    window.LLWatchlistLive = {
      refresh: function () { tick(); },
      stop: function (handle) {
        if (!handle) return;
        var snaps = readSnap();
        delete snaps[handle];
        writeSnap(snaps);
        var seen = readSeen();
        Object.keys(seen).forEach(function (k) {
          if (k.indexOf(handle + ':') === 0) delete seen[k];
        });
        writeSeen(seen);
      }
    };

    /* Catch hub / page writes to the shared keys without editing every section. */
    try {
      var _setItem = localStorage.setItem.bind(localStorage);
      localStorage.setItem = function (key, value) {
        _setItem(key, value);
        if (key === K_WATCH || key === K_LEGACY) {
          setTimeout(function () {
            if (window.LLWatchlistLive) window.LLWatchlistLive.refresh();
          }, 500);
        }
      };
    } catch (e) {}

    document.addEventListener('ll:watchlist:change', function () {
      setTimeout(tick, 400);
    });

    window.addEventListener('storage', function (e) {
      if (!e) return;
      if (e.key === K_WATCH || e.key === K_LEGACY || e.key === K_SNAP) {
        setTimeout(tick, 300);
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });

    schedule();
    /* First pass after a short idle so it doesn't compete with page paint. */
    setTimeout(tick, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
